<div class="order-details" *ngIf="cart">
  <h4 class="title">Order Details</h4>

  <!-- Micro Products Section -->
  <ul class="list-items" *ngIf="cart.microProduct || cart?.plan == undefined">
    <div class="top">
      <li class="item-wrap d-flex label-wrap">
        <span class="label">Item(s) Total</span>
        <span class="price-label">
          {{ (totalAmountOfItems/(100 + 18))*100    | pricePipe }}
        </span>
      </li>
      
      <div *ngFor="let item of cart.items" class="itemlist">
        <span class="itemname">
          {{ item.name }}
        </span>
        <span class="item-price">
          {{ (item.price /(100 + 18))*100  | pricePipe }}
        </span>
      </div>

      <div class="gst">
        <span>18% GST</span>
        <span>
          {{ (totalAmountOfItems / (100+18)) * 18 | pricePipe }}
        </span>
      </div>
    </div>
    <li class="item-wrap d-flex total-count">
      <span class="totallabel">Grand Total</span>
      <span class="total-price">
        {{ totalAmountOfItems | pricePipe }}
      </span>
    </li>
  </ul>

  <!-- Subscription Plan Section -->
  <ul class="list-items" *ngIf="!cart.microProduct">
    <li class="item-wrap d-flex label-wrap" *ngIf="cart.plan">
      <span class="label">Item Total</span>
      <span class="label">
        {{ (cart.planPrice /(100 + 18))*100 | pricePipe }}
      </span>
    </li>
    <div class="itemlist">
      <span class="name"> {{ getSubscriptionName(cart.plan) }}</span>
      <span>{{(cart.planPrice /(100 + 18))*100 | pricePipe }}</span>
    </div>
    <hr />
    <div class="gst">
      <span>18% GST</span>
      <span>{{ (cart.planPrice /(100 + 18))*18| pricePipe }}</span>
    </div>
    <li class="item-wrap d-flex total-count" *ngIf="cart.plan">
      <span class="item-name">Total</span>
      <span class="item-price">
        {{ cart.planPrice | pricePipe }}
      </span>
    </li>
  </ul>

  <button class="btn btn-darkblue-bg" (click)="makePayment()" [disabled]="disableMicroPayment">
    Checkout Now
  </button>
</div>
